import { render, staticRenderFns } from "./TabsDestinationRelations.vue?vue&type=template&id=384e32da&"
import script from "./TabsDestinationRelations.vue?vue&type=script&lang=js&"
export * from "./TabsDestinationRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports